<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="backToUser" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center style="margin-left: 0.5rem !important">User Form</b-navbar-brand>

          <b-navbar-nav v-if="this.UserPersonalDetail.userId != '' || this.clientModal.userId != ''" class="ml-auto">
            <b-nav-form>
              <!--<b-form-input :formatter="capitalizeAll" size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
              <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>-->
              <b-button variant="warning" size="sm" @click="deleteUser">Delete User</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div v-if="this.UserPersonalDetail.userId != '' || this.clientModal.userId != ''">
              <b-button variant="info" size="sm" class="pull-right" @click="reset">Reset Password</b-button>
            </div>

            <b-modal no-close-on-esc no-close-on-backdrop id="myDIV" hide-footer ref="dialog2"
              title="Password Reset Utility">
              <b-card>
                <b-card-text>
                  <b-form>
                    <div>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <md-icon icon="envelope">no_encryption</md-icon>
                        </b-input-group-prepend>
                        <b-form-input type="text" v-model="PasswordModal.newPassword" @keyup="samePassword"
                          placeholder="Enter Password"></b-form-input>
                      </b-input-group>
                    </div>

                    <div class="gutr">
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <md-icon icon="envelope">no_encryption</md-icon>
                        </b-input-group-prepend>
                        <b-form-input type="password" required placeholder="Confirm Password"
                          v-model="PasswordModal.confPassword" @keyup="samePassword"></b-form-input>
                      </b-input-group>
                    </div>
                    <span class="error" v-if="PasswordModal.passNotMatchErr != ''">{{
                      passNotMatchErr
                    }}</span>
                    <div class="gutr">
                      <b-button class="d-block mr-0 ml-auto" variant="primary" @click="updatePassword">Reset</b-button>
                    </div>

                    <!-- <b-button type="reset" variant="danger">Reset</b-button> -->
                  </b-form>
                </b-card-text>
              </b-card>
            </b-modal>

            <!-- User Form Starts Here -->
            <div>
              <b-row>
                <b-col md="3">
                  <label>Select Employee / Client</label>
                  <model-list-select :isDisabled="clientModal.userId != ''
                    ? true
                    : UserPersonalDetail.userId == ''
                      ? false
                      : true
                    " :list="typeList" v-model="UserPersonalDetail.type" option-value="clientTypeV"
                    option-text="clientTypeT" placeholder="Select Type "></model-list-select>
                </b-col>
              </b-row>
            </div>

            <div v-if="UserPersonalDetail.type == '2'">
              <b-row>
                <b-col md="4">
                  <label>Client Name</label>
                  <model-list-select :isDisabled="clientModal.userId == '' ? false : true" :list="clientdetail"
                    v-model="clientModal.clientId" option-value="clientId" option-text="clientName" @input="getClient"
                    placeholder="Select Client "></model-list-select>
                </b-col>
                <b-col md="4">
                  <label>Client Username</label>
                  <b-form-input id="clientUserName" name="clientUserName" v-model="clientModal.clientUserName"
                    disabled></b-form-input>
                </b-col>
                <b-col md="4" v-if="clientModal.userId == ''">
                  <label>Password</label>
                  <b-form-input id="clientPass" name="clientPass" type="password"
                    v-model="clientModal.clientPass"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <md-layout class="justify-content-center mt-3" v-if="clientModal.userId == ''">
                    <b-button variant="primary" id="addButtonLoader1" @click="addClientLog">Save</b-button>
                    <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
                  </md-layout>
                </b-col>
              </b-row>
            </div>
            <div v-if="UserPersonalDetail.type == '1'">
              <b-row>
                <b-col md="6">
                  <md-layout md-flex="100">
                    <label>Employee Name</label>
                    <b-form-input :formatter="capitalizeAll" @keyup="fillUserName" id="employeeName" name="employeeName"
                      v-model="UserPersonalDetail.employeeName"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!UserPersonalDetail.employeeName">{{
                    userErrorList.employeeName
                  }}</span>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Employee Code</label>
                    <b-form-input id="employeeCode" name="employeeCode" v-model="UserPersonalDetail.employeeCode"
                      disabled></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!UserPersonalDetail.employeeCode">{{
                    userErrorList.employeeCode
                  }}</span>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Employee Username</label>
                    <b-form-input id="clientUserName" name="clientUserName" v-model="UserPersonalDetail.username"
                      @keyup="isuserNameValid"></b-form-input>
                    <!-- :disabled="UserPersonalDetail.userId!='' ?true:false" -->
                  </md-layout>
                  <span class="error" v-if="!UserPersonalDetail.username">{{
                    userErrorList.username
                  }}</span>
                  <span class="error" v-if="UserPersonalDetail.username">{{
                    erroruserFormat
                  }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <md-layout md-flex="100">
                    <label>Mobile No.</label>
                    <b-form-input id="mobileNo" name="mobileNo" v-model="UserPersonalDetail.mobileNo"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!UserPersonalDetail.mobileNo">{{
                    userErrorList.mobileNo
                  }}</span>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Landline No.</label>
                    <b-form-input id="landLineNo" name="landLineNo"
                      v-model="UserPersonalDetail.landLineNo"></b-form-input>
                  </md-layout>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Email-Id</label>
                    <b-form-input :formatter="capitalizeAll" id="email" name="email" v-model="UserPersonalDetail.email"
                      @keyup="isEmailValid"></b-form-input>
                    <span class="error" v-if="!UserPersonalDetail.email">{{
                      userErrorList.email
                    }}</span>
                    <span class="error" v-if="UserPersonalDetail.email">{{
                      errorEmailFormat
                    }}</span>
                  </md-layout>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <md-layout md-flex="100">
                    <label>Employee Designation</label>
                    <model-list-select :list="designationData" v-model="UserPersonalDetail.designation"
                      option-value="designation" option-text="designation"
                      placeholder="Select Employee Designation"></model-list-select>
                    <span class="error" v-if="!UserPersonalDetail.designation">{{
                      userErrorList.designation
                    }}</span>
                  </md-layout>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Employee Base Location</label>
                    <model-list-select @input="getBillingLocation" :list="baseLocationData"
                      v-model="UserPersonalDetail.baseLocation" option-value="pickupId" option-text="pickupLocation"
                      placeholder="Select  Location"></model-list-select>
                    <span class="error" v-if="!UserPersonalDetail.baseLocation">{{
                      userErrorList.baseLocation
                    }}</span>
                  </md-layout>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Employee Billing Branch</label>
                    <model-list-select :list="billingLocationData" v-model="UserPersonalDetail.billingLocationId"
                      option-value="billingLocationId" option-text="billingLocation"
                      placeholder="Select Billing Location"></model-list-select>
                    <span class="error" v-if="!UserPersonalDetail.baseLocation">{{
                      userErrorList.baseLocation
                    }}</span>
                  </md-layout>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <md-layout md-flex="40">
                    <label for="MultiBranch">Allow Multi-Branch</label>
                    <multi-select :options="MultiLocationList" :selected-options="items"
                      v-model="UserPersonalDetail.multibranch" placeholder="Select Multi-Branch" :multiple="true"
                      @select="SelectMultiBranch">
                    </multi-select>
                  </md-layout>
                </b-col>
                <b-col md="6">
                  <md-layout md-flex="40">
                    <label for="MultiPaymentTab">Allow Payment Tab</label>
                    <multi-select :options="MultiPaymentTabList" :selected-options="PaymentTabitems"
                      v-model="UserPersonalDetail.multiPaymentTab" placeholder="Select Multi Payment Tab" :multiple="true"
                      @select="SelectMultiPaymentTab">
                    </multi-select>
                  </md-layout>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12"><u><b>Preference</b></u></b-col>
                <b-col md="3">
                  <label for="transportType">Transport Preference</label>
                  <model-list-select :list="transportTypeList" v-model="UserPersonalDetail.transportTypePre"
                    option-value="transportTypeVal" option-text="transportTypeText"
                    placeholder="Select Transport Preference"></model-list-select></b-col>
                <b-col md="12"><u><b>Preference</b></u></b-col>
                <b-col md="3">
                  <label for="transportType">Branch/Client Preference</label>
                  <model-list-select :list="branchClientList" v-model="UserPersonalDetail.branchclientPre"
                    option-value="BCVal" option-text="BCText"
                    placeholder="Select Transport Preference"></model-list-select></b-col>

                <b-col md="3">
                  <label for="transportType">Page View Preference</label>
                  <model-list-select :list="pageViewPreferenceList" v-model="UserPersonalDetail.user_view_page_pref"
                    option-value="UPVal" option-text="UPText"
                    placeholder="Select Page View Preference"></model-list-select></b-col>

                <b-col md="12"><u><b>Preference</b></u></b-col>
                <b-col md="3">
                  <label for="transportType">Pendency Dashboard (User Access)</label>
                  <model-list-select :list="UserPreferenceList" v-model="UserPersonalDetail.user_pre"
                    option-value="UPVal" option-text="UPText"
                    placeholder="Select User Preference"></model-list-select></b-col>
                <b-col md="3">
                  <label for="transportType">Multi Update (User Access)</label>
                  <model-list-select :list="MultiUpdatePreferenceList"
                    v-model="UserPersonalDetail.is_access_multi_update" option-value="UPVal" option-text="UPText"
                    placeholder="Select Multi Update"></model-list-select></b-col>
              </b-row>
              
              <!-- Rights Management Component -->
              <b-row v-if="UserPersonalDetail.designation != ''" class="mb-2">
                <b-col md="12">
                  <label>Require Validation for Rights</label>
                  <b-form-checkbox
                    class="ml-2"
                    style="margin-top: 7px"
                    v-model="UserPersonalDetail.ape_rights_require_validation"
                    name="ape_rights_require_validation"
                    :value="true"
                    :unchecked-value="false"
                  >
                  </b-form-checkbox>
                  <span style="margin-top: 10px">{{ UserPersonalDetail.ape_rights_require_validation ? 'Yes' : 'No' }}</span>
                </b-col>
              </b-row>
              <RightsManagementComponent 
                :userData="UserPersonalDetail" 
                :showSection="UserPersonalDetail.designation != ''"
                :requireValidation="UserPersonalDetail.ape_rights_require_validation"
                @rights-data-changed="handleRightsDataChanged"
                ref="rightsManagement" />
              
              <!-- User Profile Section -->
              <div class="mt-3 p-4" style="background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 5px;" v-if="UserPersonalDetail.designation != ''">
                <b-row>
                  <b-col md="12">
                    <h6>
                      <b-badge variant="info">User Profile</b-badge>
                    </h6>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="6">
                    <md-layout md-flex="100">
                      <label>Approver Flag</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-flag"
                        v-model="UserPersonalDetail.purchase_approver_flag" name="approver-flag" value="Yes"
                        unchecked-value="No">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{
                          UserPersonalDetail.purchase_approver_flag == "" || UserPersonalDetail.purchase_approver_flag == "No"
                            ? "No"
                            : "Yes"
                        }}
                      </span>
                    </md-layout>
                  </b-col>
                </b-row>
              </div>

              <!-- Approver Rights Management Section -->
              <!-- <div class="mt-3 p-4" style="background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 5px;" v-if="UserPersonalDetail.designation != '' && UserPersonalDetail.purchase_approver_flag == 'Yes'">
                <b-row>
                  <b-col md="12">
                    <h6>
                      <b-badge variant="success">Approver Rights Management</b-badge>
                    </h6>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Invoice Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-invoice"
                        v-model="UserPersonalDetail.approverRights.invoiceApproval" name="approver-invoice"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.invoiceApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Expense Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-expense"
                        v-model="UserPersonalDetail.approverRights.expenseApproval" name="approver-expense"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.expenseApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Payment Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-payment"
                        v-model="UserPersonalDetail.approverRights.paymentApproval" name="approver-payment"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.paymentApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Manifestation Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-manifestation"
                        v-model="UserPersonalDetail.approverRights.manifestationApproval" name="approver-manifestation"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.manifestationApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Credit/Debit Note Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-crdr"
                        v-model="UserPersonalDetail.approverRights.crdrNoteApproval" name="approver-crdr"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.crdrNoteApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Billing Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-billing"
                        v-model="UserPersonalDetail.approverRights.billingApproval" name="approver-billing"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.billingApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Proforma Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-proforma"
                        v-model="UserPersonalDetail.approverRights.proformaApproval" name="approver-proforma"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.proformaApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Quotation Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-quotation"
                        v-model="UserPersonalDetail.approverRights.quotationApproval" name="approver-quotation"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.quotationApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                  <b-col md="4">
                    <md-layout md-flex="100">
                      <label>Maintenance Approval</label>
                      <b-form-checkbox class="ml-2" style="margin-top: 7px" id="approver-maintenance"
                        v-model="UserPersonalDetail.approverRights.maintenanceApproval" name="approver-maintenance"
                        :value="true" :unchecked-value="false">
                      </b-form-checkbox>
                      <span style="margin-top: 10px">
                        {{ UserPersonalDetail.approverRights.maintenanceApproval ? "Yes" : "No" }}
                      </span>
                    </md-layout>
                  </b-col>
                </b-row>
              </div> -->
              
              <b-row v-if="UserPersonalDetail.designation != ''">
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Management Dashboard Access</label>
                    <b-form-checkbox class="ml-2" style="margin-top: 7px" id="checkbox-1"
                      v-model="UserPersonalDetail.dashBoardPermission" name="checkbox-1" value="Yes"
                      unchecked-value="No">
                    </b-form-checkbox>
                    <span style="margin-top: 10px">
                      {{
                        UserPersonalDetail.dashBoardPermission == ""
                          ? "No"
                          : UserPersonalDetail.dashBoardPermission
                      }}</span>
                  </md-layout>
                </b-col>
                <b-col md="3" v-if="
                  UserPersonalDetail.finalPagePermision.indexOf('Analysis_Dashboard') >=
                  0
                ">
                  <md-layout md-flex="100">
                    <label>Growth Access</label>
                    <b-form-checkbox class="ml-2" style="margin-top: 7px" id="checkbox-2"
                      v-model="UserPersonalDetail.growthPermission" name="checkbox-2" value="Yes"
                      unchecked-value="No"></b-form-checkbox>
                    <span style="margin-top: 10px">
                      {{
                        UserPersonalDetail.growthPermission == ""
                          ? "No"
                          : UserPersonalDetail.growthPermission
                      }}</span>
                  </md-layout>
                </b-col>
                <b-col md="3" v-if="
                  UserPersonalDetail.finalPagePermision.indexOf('Request For Quotation') >=
                  0
                ">
                  <md-layout md-flex="100">
                    <label>Maintanence Approval Preference</label>
                    <b-form-checkbox class="ml-2" style="margin-top: 7px" id="checkbox-3"
                      v-model="UserPersonalDetail.maint_app_preference" name="checkbox-3" value="Yes"
                      unchecked-value="No"></b-form-checkbox>
                    <span style="margin-top: 10px">
                      {{
                        UserPersonalDetail.maint_app_preference == ""
                          ? "No"
                          : UserPersonalDetail.maint_app_preference
                      }}</span>
                  </md-layout>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="100">
                    <label>Add Resp Vendor Access</label>
                    <b-form-checkbox class="ml-2" style="margin-top: 7px" id="checkbox-5"
                      v-model="UserPersonalDetail.maint_reponse_vendor" name="checkbox-5" value="Yes"
                      unchecked-value="No">
                    </b-form-checkbox>
                    <span style="margin-top: 10px">
                      {{
                        UserPersonalDetail.maint_reponse_vendor == ""
                          ? "No"
                          : UserPersonalDetail.maint_reponse_vendor
                      }}</span>
                  </md-layout>
                </b-col>
              </b-row>
              <div class="mt-3 p-4" style="background: whitesmoke" v-if="UserPersonalDetail.designation != ''">
                <b-row>
                  <b-col md="12">
                    <div v-if="UserPersonalDetail.designation != ''">
                      <md-layout md-flex="5"></md-layout>
                      <h6>
                        <b-badge>Department Permissions</b-badge>
                      </h6>
                      <span class="error" v-if="UserPersonalDetail.departmentId1.length == 0">{{ employeeDepartmentErr
                      }}</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="UserPersonalDetail.designation != ''">
                  <b-col md="4" v-for="(segmentNameArray, index) in showSegmentArrayList" :key="index" :md-flex="30">
                    <md-checkbox v-model="UserPersonalDetail.employeeDepartment[index]" class="md-primary"
                      :md-value="segmentNameArray.departmentId" :name="'employeeDepartment' + (index + 1)"
                      :id="'employeeDepartment' + (index + 1)" @change="
                        employeeDepartmentSelect(segmentNameArray.departmentId, index)
                        ">{{ segmentNameArray.departmentName }}</md-checkbox>
                  </b-col>
                </b-row>
              </div>
              <div class="mt-3 p-4" style="background: whitesmoke" v-if="UserPersonalDetail.pagePermision.length > 0">
                <b-row>
                  <b-col md="12">
                    <h6>
                      <b-badge>Specific Page Permissions of selected departments</b-badge>
                    </h6>
                  </b-col>
                </b-row>
                <div>
                  <md-layout md-gutter md-flex="100" class="gutr"
                    v-for="(segmentNameArray1, index) in UserPersonalDetail.pagePermision" :key="index">
                    <md-layout md-flex="100">
                      <h6 class="pl-2">
                        <b-badge variant="light">{{
                          segmentNameArray1.departmentName
                        }}</b-badge>
                      </h6>
                    </md-layout>
                    <div style="width: 100%">
                      <b-row>
                        <b-col md="4" v-for="(segmentNameArray, index1) in segmentNameArray1.pageName" :key="index1"
                          :md-flex="50">
                          <md-checkbox class="md-primary" v-bind:class="UserPersonalDetail.finalPagePermision.indexOf(
                            segmentNameArray
                          ) >= 0
                            ? 'md-checked checkedNew' +
                            segmentNameArray1.pageId +
                            (index1 + 1)
                            : 'checkedNew' + segmentNameArray1.pageId + (index1 + 1)
                            " :md-value="segmentNameArray" :name="'deptMas' + (index1 + 1)"
                            :id="'deptMas' + (index1 + 1)" @change="
                              employeePageName(
                                segmentNameArray,
                                index1,
                                segmentNameArray1.pageId
                              )
                              ">{{ segmentNameArray }}</md-checkbox>
                        </b-col>
                      </b-row>
                    </div>
                  </md-layout>
                </div>
              </div>
              <div v-if="showportloginacc == true">
                <b-row>
                  <b-col md="12">
                    <label>Port Login Access</label>
                    <model-list-select :list="PortList" v-model="UserPersonalDetail.portLoginAccess"
                      option-value="portV" option-text="portT" placeholder="Select "></model-list-select>
                  </b-col>
                </b-row>
              </div>
              <div v-if="
                UserPersonalDetail.designation != 'HOD' &&
                UserPersonalDetail.designation != 'Admin' &&
                UserPersonalDetail.designation != '' &&
                userMasterList.length > 0 &&
                UserPersonalDetail.departmentId1.length > 0
              ">
                <b-row>
                  <b-col md="6">
                    <label>{{
                      this.UserPersonalDetail.designation == "manager"
                        ? "Employee HOD"
                        : "Employee Manager"
                    }}</label>
                    <model-list-select :list="userMasterList" v-model="UserPersonalDetail.employeeHODId"
                      option-value="userId" option-text="employeeName" :placeholder="UserPersonalDetail.designation == 'manager'
                        ? 'Select HOD'
                        : 'Select Manager'
                        "></model-list-select>
                    <span class="error" v-if="!UserPersonalDetail.employeeHODId">{{
                      employeeHodError
                    }}</span>
                  </b-col>
                </b-row>
              </div>
              <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <label>
                <b>
                  <u>User Details</u>
                </b>
              </label>
              <md-layout md-flex="10"></md-layout>
            </md-layout>
              </md-layout>-->

              <!-- Added By Priyanshu Singh Start -->
              <!-- <md-layout md-gutter class="gutr">
                <md-layout md-flex="40">
                    <label>Allow Multi-Branch</label>
                    <model-list-select
                      :list="billingLocationData"
                      v-model="UserPersonalDetail.multibranch"
                      option-value="billingLocationId"
                      option-text="billingLocation"
                      placeholder="Select Multi-Branch"
                    ></model-list-select> -->
              <!-- <multi-select
                      :options="billingLocationData"
                      :selected-options="UserPersonalDetail.multibranch"
                      placeholder="Select Multi-Branch"
                      @select="SelectMultiBranch"
                    >
                    </multi-select>
                </md-layout>
              </md-layout> -->

              <!-- Added By Priyanshu Singh End -->
              <md-layout md-gutter class="gutr" v-if="this.NoteArray == true">
                <md-layout md-flex="50">
                  <h4 class="error" v-if="UserPersonalDetail.designation != 'manager'">
                    Note:-You Do Not Have Any Manager For Selected Employee Department..!
                  </h4>
                  <h4 class="error" v-else>
                    Note:-You Do Not Have Any HOD For Selected Manager Department..!
                  </h4>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr" v-if="this.departmentError.length > 0">
                <md-layout md-flex="50">
                  <h4 class="error">
                    Note: Select aleast one permission in this {{ departmentErrorList }}
                  </h4>
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout class="justify-content-center mt-3">
                  <h4 style="color: red">
                    {{ error.message.length > 0 ? error.message : "" }}
                  </h4>
                  <b-button class="smbutnWidth" variant="primary" id="addButtonLoader" @click="addUser"
                    :disabled="NoteArray">Save</b-button>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop" @close="onClose"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="resetPassword"></md-dialog-alert>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="deleteUserPop"
      ref="addPopDelete"></md-dialog-confirm>
  </div>
</template>

<script>
import Vue from "vue";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import RightsManagementComponent from "../../common/RightsManagementComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import Multiselect from "vue-multiselect";

export default {
  beforeMount() {
    if (globalPermissionStatus("Main Master")) {
      this.$store.dispatch("setCurrentRoute", "/userManagement/addUser");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      userId:
        this.$sessionsStorage.get("editUserPerId") != ""
          ? this.$sessionsStorage.get("editUserPerId")
          : "",
      isLoading: true,
      allPermission: "",

      genericObject: {},
      clientModal: {
        clientId: "",
        clientUserName: "",
        clientPass: "",
        userId: "",
      },
      items: [],
      PaymentTabitems: [],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
        {
          transportTypeVal: "All",
          transportTypeText: "All",
        },
      ],
      branchClientList: [
        {
          BCVal: "1",
          BCText: "Branch",
        },
        {
          BCVal: "2",
          BCText: "Client",
        },
      ],
      pageViewPreferenceList: [
        {
          UPVal: "1",
          UPText: "Yes",
        },
        {
          UPVal: "0",
          UPText: "No",
        },
      ],
      UserPreferenceList: [
        {
          UPVal: "1",
          UPText: "Yes",
        },
        {
          UPVal: "2",
          UPText: "No",
        },
      ],
      MultiUpdatePreferenceList: [
        {
          UPVal: "1",
          UPText: "Yes",
        },
        {
          UPVal: "0",
          UPText: "No",
        },
      ],
      UserPersonalDetail: {
        user_view_page_pref: "0",
        user_pre: "2",
        is_access_multi_update: "0",
        ape_rights_require_validation: "0",
        transportTypePre: "All",
        branchclientPre: "1",
        dashBoardPermission: "No",
        growthPermission: "No",
        maint_app_preference: "No",
        maint_reponse_vendor: "No",
        portLoginAccess: "0",
        billingLocationId: "",
        multibranch: [],
        multiPaymentTab: [],
        billingLocationName: "",
        username: "",
        userId: "",
        employeeCode: "",
        employeeName: "",
        type: "",
        departmentId1: [],

        finalPagePermision: [],

        pagePermision: [],
        landLineNo: "",
        mobileNo: "",
        email: "",
        baseLocation: "",
        designation: "",
        employeeDepartment: [],
        employeeHODId: "",
        ape_shipment_type: [],
        ape_moduel_type: [],
        ape_job_type: [],
        purchase_approver_flag: "No",
        approverRights: {
          invoiceApproval: false,
          expenseApproval: false,
          paymentApproval: false,
          manifestationApproval: false,
          crdrNoteApproval: false,
          billingApproval: false,
          proformaApproval: false,
          quotationApproval: false,
          maintenanceApproval: false,
        },
      },
      passNotMatchErr: "",
      PasswordModal: {
        newPassword: "",
        confPassword: "",
      },

      pageMasterName: [],
      tempPageMasterName: [],
      deleteId: "",
      idNew: "",
      oldDesignaion: "",
      NoteArray: false,

      error: { message: "" },
      alreadyUser: "",
      errorAlreadyUser: false,
      stateDetail: [],
      userMaster: [],
      tempUserMaster: [],
      clientdetail: [],
      showSegmentArray: [],
      tempShowSegmentArray: [],
      designationData: [],
      typeList: [
        {
          clientTypeV: "1",
          clientTypeT: "Employee",
        },
        {
          clientTypeV: "2",
          clientTypeT: "Client",
        },
      ],
      PortList: [
        {
          portV: "1",
          portT: "Yes",
        },
        {
          portV: "0",
          portT: "No",
        },
      ],
      showportloginacc: false,
      MultiLocationList: [],
      MultiPaymentTabList: [
        {
          text: "S/Line Payment Planning",
          value: "slinePaymentPlanning",
          section: "Sea_Export_SLine_Payment",
          menu_name: "Payment Request",
          tab_name: "S/Line Payment Planning"
        },
        {
          text: "S/Line Payment Shortlist",
          value: "slinePaymentShortlist",
          section: "Sea_Export_SLine_Payment",
          menu_name: "Payment Request",
          tab_name: "S/Line Payment Shortlist"
        },
        {
          text: "S/Line Payment Processing",
          value: "slinePaymentProcessing",
          section: "Sea_Export_SLine_Payment",
          menu_name: "Payment Request",
          tab_name: "S/Line Payment Processing"
        },
        {
          text: "S/Line Payment Finalized",
          value: "slinePaymentFinalized",
          section: "Sea_Export_SLine_Payment",
          menu_name: "Payment Request",
          tab_name: "S/Line Payment Finalized"
        },
        {
          text: "S/Line Payment Request Final",
          value: "slinePaymentRequestFinal",
          section: "Sea_Export_SLine_Payment",
          menu_name: "Payment Request",
          tab_name: "S/Line Payment Request Final"
        }
      ],

      baseLocationData: [],
      billingLocationData: [],
      employeeDepartmentSelectVal: false,
      employeeHodError: "",
      departmentError: [],
      departmentErrorList: "",
      validate: true,
      ape_rights_require_validation: false,
      userErrorList: {
        username: "",
        employeeName: "",
        employeeCode: "",
        baseLocation: "",
        mobileNo: "",
        email: "",
        designation: "",
      },
      userError: {
        username: "Enter User Name",
        employeeName: "Enter Employee Name",
        employeeCode: "Enter Employee Code",
        baseLocation: "Select Base Location",
        mobileNo: "Enter Mobile No.",
        email: "Enter Email Address",
        designation: "Select Designation",
      },
      employeeDepartmentErr: "",
      errorEmailFormat: "",
      erroruserFormat: "",
      alert: {
        content:
          this.$sessionsStorage.get("editUserPerId") != "" &&
            this.$sessionsStorage.get("editUserPerId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editUserPerId") != "" &&
            this.$sessionsStorage.get("editUserPerId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editUserPerId") != "" &&
            this.$sessionsStorage.get("editUserPerId") != undefined
            ? "Update"
            : "New",
      },
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() { },
  watch: {
    UserPersonalDetail: {
      handler: function (newVal, oldVal) {
        if (this.oldDesignaion == "" && this.UserPersonalDetail.designation != "") {
          this.oldDesignaion = this.UserPersonalDetail.designation;

          this.newArray("1");
        } else if (this.oldDesignaion == this.UserPersonalDetail.designation) {
        } else {
          this.oldDesignaion = this.UserPersonalDetail.designation;
          this.UserPersonalDetail.employeeHODId = "";
          this.UserPersonalDetail.departmentId1 = [];

          this.newArray("2");
        }
        if (this.UserPersonalDetail.employeeDepartment[6] == true) {
          this.showportloginacc = true;
        } else {
          this.showportloginacc = false;
        }
        
        // Reset approverRights when purchase_approver_flag is set to "No"
        if (oldVal && newVal.purchase_approver_flag == "No" && oldVal.purchase_approver_flag == "Yes") {
          this.UserPersonalDetail.approverRights = {
            invoiceApproval: false,
            expenseApproval: false,
            paymentApproval: false,
            manifestationApproval: false,
            crdrNoteApproval: false,
            billingApproval: false,
            proformaApproval: false,
            quotationApproval: false,
            maintenanceApproval: false,
          };
        }
      },
      deep: true,
    },
  },

  beforeDestroy() {
    this.$sessionsStorage.set("editUserPerId", "");
  },

  destroyed() { },

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    RightsManagementComponent,
    Multiselect,
    MultiSelect,
    // MultiSelect
  },

  computed: {
    userMasterList() {
      return this.userMaster;
    },
    showSegmentArrayList() {
      return this.showSegmentArray;
    },
    transportTypeList() {
      return this.transportTypeName;
    },
  },

  methods: {
    getBillingLocation() {
      //  console.log(this.UserPersonalDetail.baseLocation);
      this.billingLocationData.map((x, index) => {
        if (x.branchLocation.split(",").includes(this.UserPersonalDetail.baseLocation)) {
          this.UserPersonalDetail.billingLocationId = x.billingLocationId;
          this.UserPersonalDetail.billingLocationName = x.billingLocation;
        }
      });

      // let dummyBillLoc = this.billingLocationData.filter(x => {
      //   return x.branchLocation == this.UserPersonalDetail.baseLocation;
      // });

      // console.log(this.UserPersonalDetail.baseLocation);
      // if (dummyBillLoc.length > 0) {
      //   console.log(dummyBillLoc);

      //   this.UserPersonalDetail.billingLocationId =
      //     dummyBillLoc[0].billingLocationId;
      //   this.UserPersonalDetail.billingLocationName =
      //     dummyBillLoc[0].billingLocation;
      // }
    },
    getClient() {
      let filterClientList = this.clientdetail.filter((x) => {
        return x.clientId == this.clientModal.clientId;
      });
      this.clientModal.clientUserName = filterClientList[0].email;
      console.log(filterClientList);
    },
    closeModal() {
      (this.PasswordModal.newPassword = ""),
        (this.PasswordModal.confPassword = ""),
        this.$refs["dialog2"].close();
    },
    samePassword() {
      if (
        this.PasswordModal.newPassword != this.PasswordModal.confPassword &&
        this.PasswordModal.confPassword.length > 4
      ) {
        this.passNotMatchErr = "Passwords do not match";
      } else {
        this.passNotMatchErr = "";
      }
    },
    reset() {
      this.$refs["dialog2"].show();
    },

    updatePassword() {
      if (this.PasswordModal.newPassword <= 4) {
        this.passNotMatchErr = "Password length should be 5 character atleast";
        return false;
      } else {
        this.passNotMatchErr = "";
      }
      if (this.PasswordModal.newPassword != this.PasswordModal.confPassword) {
        this.passNotMatchErr = "Passwords do not match";
        return false;
      } else {
        this.passNotMatchErr = "";
      }
      this.PasswordModal["UpdateUserPassId"] = this.$sessionsStorage.get("editUserPerId");

      let options = {
        method: "POST",
        url: `${URL_BASE}/resetPassword.php`,
        data: JSON.stringify(this.PasswordModal),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            this.getData();

            this.$refs["dialog2"].close();
            this.alert.content = "Password Updated Succesfully";
            this.$refs["resetPassword"].open();

            this.PasswordModal.newPassword = "";
            this.PasswordModal.confPassword = "";
          }
        })
        .catch((error) => { });
    },

    deleteUser() {
      this.deleteId = this.UserPersonalDetail.userId;

      this.alert.content = "Are you sure you want to Delete this User?";
      this.$refs["addPopDelete"].open();
    },

    deleteUserPop(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "users",
          tableId: "userId",
          tableIsActive: "isActive",
          value1: 2,
          tableVal: this.deleteId,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/activateUser.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$router.push({
                path: "/userManagement/viewUserDetail",
              });
            }
          })
          .catch((error) => { });
      }
    },
    fillUserName() {
      if (this.UserPersonalDetail.userId == "") {
        let user = this.UserPersonalDetail.employeeName.toLowerCase();
        this.UserPersonalDetail.username = user.replace(/\s/g, "");
        this.isuserNameValid();
      }
    },
    isuserNameValid() {
      if (
        this.UserPersonalDetail.username != "" &&
        this.UserPersonalDetail.userId == ""
      ) {
        // this.UserPersonalDetail.username;
        let arrayNew = this.tempUserMaster.filter((x) => {
          return x.username == this.UserPersonalDetail.username;
        });

        if (arrayNew.length > 0) {
          this.erroruserFormat = "Username Already Exist";
        } else {
          this.erroruserFormat = "";
        }
      }
    },
    isEmailValid() {
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.UserPersonalDetail.email)) {
        this.errorEmailFormat = "";
      } else {
        this.errorEmailFormat = "Enter Valid Email";
      }
    },
    backToUser() {
      this.$router.push({
        path: "/userManagement/viewUserDetail",
      });
    },
    validateUser() {
      let validate_new = true;

      Object.keys(this.userErrorList).map((x) => {
        if (this.UserPersonalDetail[x] == "") {
          this.userErrorList[x] = this.userError[x];
          validate_new = false;
        }
      });

      if (this.UserPersonalDetail.departmentId1.length == 0) {
        this.employeeDepartmentErr = "Select Atleast 1 Department";

        validate_new = false;
      } else {
        this.employeeDepartmentErr = "";
      }

      if (
        this.UserPersonalDetail.designation != "HOD" &&
        this.UserPersonalDetail.designation != "Admin" &&
        this.UserPersonalDetail.designation != ""
      ) {
        if (this.UserPersonalDetail.employeeHODId == "") {
          var design =
            this.UserPersonalDetail.designation == "manager" ? "HOD" : "manager";
          this.employeeHodError = "Select " + design;

          validate_new = false;
        } else {
          this.employeeHodError = "";
        }
      }

      // Validate Rights Management fields using child component
      if (this.$refs.rightsManagement) {
        const rightsErrors = this.$refs.rightsManagement.triggerValidation();
        if (rightsErrors.length > 0) {
          validate_new = false;
        }
      }
      // let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      // if (emailreg.test(this.UserPersonalDetail.email)) {
      //   let arrayNew = this.tempUserMaster.filter(x => {
      //     return x.email == this.UserPersonalDetail.email;
      //   });
      //   if (arrayNew.length > 0) {
      //     this.errorEmailFormat = "Email Already Exist";
      //     this.alert.content = "Email Already Exist..!";
      //     this.$refs["resetPassword"].open();
      //     validate_new = false;
      //   } else {
      //     this.errorEmailFormat = "";
      //   }
      // } else {
      //   this.errorEmailFormat = "Enter Valid Email";
      //   this.alert.content = "Enter Valid Email..!";
      //   this.$refs["resetPassword"].open();
      //   validate_new = false;
      // }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    arr_diff(a1, a2) {
      var a = [],
        diff = [];

      for (var i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
      }

      for (var i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
          delete a[a2[i]];
        } else {
          a[a2[i]] = true;
        }
      }

      for (var k in a) {
        diff.push(k);
      }

      return diff;
    },

    addClientLog() {
      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        //  return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/clientLoginDetailsAdd.php`,
          data: JSON.stringify(this.clientModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              // if (this.UserPersonalDetail.userId == "") {
              //   this.alert.content = "Data Added Successfully";
              //   this.$refs["addPop"].open();
              // } else {
              //   this.alert.content = "Data Updated Successfully";
              //   this.$refs["addPop"].open();
              // }
              this.getData();
            }
          })
          .catch((error) => { });
      }
    },
    addUser() {
      this.validateUser();
      this.departmentError = [];
      let arrayMain = [];
      let arrayAlready = [];
      this.departmentErrorList = "";
      console.log('this.UserPersonalDetail=>',this.UserPersonalDetail);
      // return false;

      // console.log(
      //   this.UserPersonalDetail.pagePermision[0].pageName.length,
      //   this.UserPersonalDetail
      // );

      for (let i = 0; i < this.UserPersonalDetail.pagePermision.length; i++) {
        arrayMain.push(this.UserPersonalDetail.pagePermision[i].departmentName);
        for (
          let j = 0;
          j < this.UserPersonalDetail.pagePermision[i].pageName.length;
          j++
        ) {
          let k = this.UserPersonalDetail.finalPagePermision.indexOf(
            this.UserPersonalDetail.pagePermision[i].pageName[j]
          );

          if (k >= 0) {
            arrayAlready.push(this.UserPersonalDetail.pagePermision[i].departmentName);

            break;
          }
        }
      }

      this.departmentError = this.arr_diff(arrayMain, arrayAlready);
      this.departmentErrorList = this.departmentError.join(", ");

      if (this.departmentError.length > 0) {
        // var newStr = this.departmentErrorList.substring(
        //   0,
        //   this.departmentErrorList.length - 2
        // );
        // this.departmentErrorList = newStr;

        return false;
      }

      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.UserPersonalDetail.email)) {
        this.errorEmailFormat = "";
      } else {
        this.errorEmailFormat = "Enter Valid Email";
      }

      if (
        this.UserPersonalDetail.username != "" &&
        this.UserPersonalDetail.userId == ""
      ) {
        let arrayNew = this.tempUserMaster.filter((x) => {
          return x.username == this.UserPersonalDetail.username;
        });

        if (arrayNew.length > 0) {
          this.erroruserFormat = "Username Already Exist";
          this.alert.content = "Username Already Exist..!";
          this.$refs["resetPassword"].open();
          return false;
        } else {
          this.erroruserFormat = "";
        }
      }

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        // Prepare data for saving
        let userDataToSave = Object.assign({}, this.UserPersonalDetail);
        
        // If purchase_approver_flag is "No", reset approverRights to default values
        if (userDataToSave.purchase_approver_flag == "No" || userDataToSave.purchase_approver_flag == "") {
          userDataToSave.approverRights = {
            invoiceApproval: false,
            expenseApproval: false,
            paymentApproval: false,
            manifestationApproval: false,
            crdrNoteApproval: false,
            billingApproval: false,
            proformaApproval: false,
            quotationApproval: false,
            maintenanceApproval: false,
          };
        }
        
        // Stringify approverRights object for backend storage
        userDataToSave.approverRights = JSON.stringify(userDataToSave.approverRights);

        //  return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addUsers.php`,
          data: JSON.stringify(userDataToSave),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.UserPersonalDetail.userId == "") {
                this.alert.content = "Data Added Successfully";
                this.$refs["addPop"].open();
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              this.getData();
            }
          })
          .catch((error) => { });
      }
    },
    employeeDepartmentSelect(value, index) {
      if (this.UserPersonalDetail.departmentId1.length == 0) {
        this.UserPersonalDetail.departmentId1.push(value);
      } else {
        let i = this.UserPersonalDetail.departmentId1.indexOf(value);
        if (i >= 0) {
          this.UserPersonalDetail.departmentId1.splice(i, 1);
        } else {
          this.UserPersonalDetail.departmentId1.push(value);
        }
      }
      this.newArray("1");
    },

    employeePageName(value, index, pageId) {
      if (this.UserPersonalDetail.finalPagePermision.length == 0) {
        this.UserPersonalDetail.finalPagePermision.push(value);
      } else {
        let i = this.UserPersonalDetail.finalPagePermision.indexOf(value);

        if (i >= 0) {
          $(document).ready(function () {
            $(".checkedNew" + pageId + (index + 1)).removeClass("md-checked");
          });

          this.UserPersonalDetail.finalPagePermision.splice(i, 1);
        } else {
          this.UserPersonalDetail.finalPagePermision.push(value);
        }

        // this.genericObject["permissions" + index];
      }
    },

    newArray(id11) {
      let arrayNew = [];

      if (
        this.UserPersonalDetail.designation == "surveyer" ||
        this.UserPersonalDetail.designation == "superviser"
      ) {
        let arrayNew23 = this.designationData.filter((x) => {
          return x.designation == this.UserPersonalDetail.designation;
        });

        if (arrayNew23.length > 0) {
          let arrapSplit = arrayNew23[0].departmentName.split(",");

          this.showSegmentArray = this.tempShowSegmentArray.filter((y, index) => {
            return arrapSplit.indexOf(y.departmentName) >= 0 ? true : false;
          });
        }
      } else {
        this.showSegmentArray = this.tempShowSegmentArray;
      }

      if (id11 == "2") {
        this.UserPersonalDetail.employeeDepartment = Array(
          this.showSegmentArray.length
        ).fill(false);
      }

      //       &&   this.UserPersonalDetail.designation != "HOD"
      if (this.UserPersonalDetail.departmentId1.length > 0) {
        this.UserPersonalDetail.pagePermision = [];

        this.UserPersonalDetail.departmentId1.map((y) => {
          let arrayCheck = this.pageMasterName.filter((x) => {
            return x.departmentId == y;
          });

          if (arrayCheck.length > 0) {
            let obj = {
              pageId: arrayCheck[0].pageId,
              departmentName: arrayCheck[0].departmentName,
              pageName: arrayCheck[0].pageName.split(","),
            };
            this.UserPersonalDetail.pagePermision.push(obj);
          }
        });

        if (
          this.UserPersonalDetail.designation != "manager" &&
          this.UserPersonalDetail.designation != "HOD"
        ) {
          this.tempUserMaster.map((x, index) => {
            if (x.designation == "manager") {
              arrayNew.push(x);
              //               let arraynew2 = x.departmentId1.split(",");

              //               for (
              //                 let ik = 0;
              //                 ik < this.UserPersonalDetail.departmentId1.length;
              //                 ik++
              //               ) {
              //                 let y = this.UserPersonalDetail.departmentId1[ik];
              // if(y!='10013'){
              //                 let indexNew = arraynew2.indexOf(y);
              //                 if (indexNew >= 0) {
              //                   this.idNew = "fdsf";
              //                 } else {
              //                   this.idNew = "";

              //                   break;
              //                 }
              // }
              //               }

              //               if (arrayNew.length > 0) {
              //                 if (this.idNew != "") {
              //                   arrayNew.push(x);
              //                   this.idNew = "";
              //                 }
              //               } else {
              //                 if (this.idNew == "") {
              //                   arrayNew = [];
              //                 } else {
              //                   arrayNew.push(x);
              //                   this.idNew = "";
              //                 }
              //               }
            }
          });
        } else if (this.UserPersonalDetail.designation == "manager") {
          this.tempUserMaster.map((x, index) => {
            if (x.designation == "HOD") {
              arrayNew.push(x);
              // let arraynew2 = x.departmentId1.split(",");

              // for (
              //   let ik = 0;
              //   ik < this.UserPersonalDetail.departmentId1.length;
              //   ik++
              // ) {
              //   let y = this.UserPersonalDetail.departmentId1[ik];

              //   let indexNew = arraynew2.indexOf(y);
              //   if (indexNew >= 0) {
              //     this.idNew = "fdsf";
              //   } else {
              //     this.idNew = "";

              //     break;
              //   }
              // }

              // if (arrayNew.length > 0) {
              //   if (this.idNew != "") {
              //     arrayNew.push(x);
              //     this.idNew = "";
              //   }
              // } else {
              //   if (this.idNew == "") {
              //     arrayNew = [];
              //   } else {
              //     arrayNew.push(x);
              //     this.idNew = "";
              //   }
              // }
            }
          });
        }

        this.userMaster = arrayNew;
        if (
          this.userMaster.length == 0 &&
          this.UserPersonalDetail.designation != "HOD" &&
          this.UserPersonalDetail.designation != "Admin"
        ) {
          this.NoteArray = true;
        } else {
          this.NoteArray = false;
        }
      } else {
        this.userMaster = this.tempUserMaster;
        this.UserPersonalDetail.pagePermision = [];
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleSizenew").DataTable();
      });
    },

    onClose(type) {
      this.$router.push({
        path: "/userManagement/viewUserDetail",
      });
    },

    getData() {
      this.isLoading = true;
      let type_Size = {
        user: "1",
        userId: this.$sessionsStorage.get("editUserPerId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewUser.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            }

            if (data.userDetails.length > 0) {
              this.userMaster = data.userDetails;
              this.tempUserMaster = data.userDetails;
            } else {
              this.userMaster = [];
            }
            console.log(data, "79897");
            if (data.clientdetail.length > 0) {
              this.clientdetail = data.clientdetail;
            } else {
              this.clientdetail = [];
            }

            if (data.departmentMasterData.length > 0) {
              this.showSegmentArray = data.departmentMasterData;
              this.tempShowSegmentArray = data.departmentMasterData;
            } else {
              this.showSegmentArray = [];
            }

            if (data.pageDepartmentMaster.length > 0) {
              this.pageMasterName = data.pageDepartmentMaster;
              // this.tempPageMasterName = data.pageDepartmentMaster;
            } else {
              this.showSegmentArray = [];
            }
            if (data.desinationMasterData.length > 0) {
              if (this.$sessionsStorage.get("designation") == "Admin") {
                this.designationData = data.desinationMasterData;
              } else {
                this.designationData = data.desinationMasterData.filter((x) => {
                  return x.designation != "Admin";
                });
              }
            } else {
              this.designationData = [];
            }
            if (data.baseLocationDetails.length > 0) {
              this.baseLocationData = data.baseLocationDetails;
            } else {
              this.baseLocationData = [];
            }

            if (data.billingLocationData.length > 0) {
              this.billingLocationData = data.billingLocationData;
            } else {
              this.billingLocationData = [];
            }

            if (data.MultiLocationList.length > 0) {
              this.MultiLocationList = data.MultiLocationList;
            } else {
              this.MultiLocationList = [];
            }
            console.log("this.MultiLocationList=> ", this.MultiLocationList);
            // console.log("data.userDataDetails[0].multibranch=> " , data.userDataDetails[0].multibranch);
            // alert(data.userDataDetails.length);
            if (data.userDataDetails.length > 0) {
              if (
                data.userDataDetails[0].multibranch != "" &&
                data.userDataDetails[0].multibranch != null
              ) {
                this.UserPersonalDetail.multibranch = JSON.parse(
                  data.userDataDetails[0].multibranch
                );
                this.items = JSON.parse(data.userDataDetails[0].multibranch);
              } else {
                this.UserPersonalDetail.multibranch = [];
                this.items = [];
              }

              if (
                data.userDataDetails[0].multiPaymentTab != "" &&
                data.userDataDetails[0].multiPaymentTab != null
              ) {
                this.UserPersonalDetail.multiPaymentTab = JSON.parse(
                  data.userDataDetails[0].multiPaymentTab
                );
                this.PaymentTabitems = JSON.parse(data.userDataDetails[0].multiPaymentTab);
              } else {
                this.UserPersonalDetail.multiPaymentTab = [];
                this.PaymentTabitems = [];
              }

              // Load Rights Management data - handled by child component
              if (
                data.userDataDetails[0].ape_shipment_type != "" &&
                data.userDataDetails[0].ape_shipment_type != null
              ) {
                this.UserPersonalDetail.ape_shipment_type = JSON.parse(
                  data.userDataDetails[0].ape_shipment_type
                );
              } else {
                this.UserPersonalDetail.ape_shipment_type = [];
              }

              if (
                data.userDataDetails[0].ape_moduel_type != "" &&
                data.userDataDetails[0].ape_moduel_type != null
              ) {
                this.UserPersonalDetail.ape_moduel_type = JSON.parse(
                  data.userDataDetails[0].ape_moduel_type
                );
              } else {
                this.UserPersonalDetail.ape_moduel_type = [];
              }

              if (
                data.userDataDetails[0].ape_job_type != "" &&
                data.userDataDetails[0].ape_job_type != null
              ) {
                this.UserPersonalDetail.ape_job_type = JSON.parse(
                  data.userDataDetails[0].ape_job_type
                );
              } else {
                this.UserPersonalDetail.ape_job_type = [];
              }
              console.log(
                "this.UserPersonalDetail.multibranch=>",
                this.UserPersonalDetail.multibranch
              );
            } else {
              this.UserPersonalDetail.multibranch = [];
              this.UserPersonalDetail.multiPaymentTab = [];
              this.UserPersonalDetail.ape_shipment_type = [];
              this.UserPersonalDetail.ape_moduel_type = [];
              this.UserPersonalDetail.ape_job_type = [];
              // this.items = [];
            }
            if (data.userDataDetails.length > 0 && data.userDataDetails[0]["type"] == 1) {
              this.UserPersonalDetail.userName = data.userDataDetails[0].username;
              console.log(data, "iuiou");

              Object.keys(this.UserPersonalDetail).map((x) => {
                if (x == "departmentId1" || x == "finalPagePermision") {
                  this.UserPersonalDetail[x] = data.userDataDetails[0][x].split(",");
                } else if (x == "approverRights") {
                  // Skip approverRights, handle separately
                } else {
                  this.UserPersonalDetail[x] = data.userDataDetails[0][x] || "";
                }
              });

              // Load purchase_approver_flag
              if (data.userDataDetails[0].purchase_approver_flag != null && data.userDataDetails[0].purchase_approver_flag != undefined) {
                this.UserPersonalDetail.purchase_approver_flag = data.userDataDetails[0].purchase_approver_flag;
              } else {
                this.UserPersonalDetail.purchase_approver_flag = "No";
              }

              // Load approverRights
              if (
                data.userDataDetails[0].approverRights != null &&
                data.userDataDetails[0].approverRights != "" &&
                data.userDataDetails[0].approverRights != undefined
              ) {
                try {
                  const approverRightsData = typeof data.userDataDetails[0].approverRights === 'string' 
                    ? JSON.parse(data.userDataDetails[0].approverRights)
                    : data.userDataDetails[0].approverRights;
                  this.UserPersonalDetail.approverRights = Object.assign({}, this.UserPersonalDetail.approverRights, approverRightsData);
                } catch (e) {
                  console.error("Error parsing approverRights:", e);
                  // Keep default values
                }
              } else {
                // Reset to default values
                this.UserPersonalDetail.approverRights = {
                  invoiceApproval: false,
                  expenseApproval: false,
                  paymentApproval: false,
                  manifestationApproval: false,
                  crdrNoteApproval: false,
                  billingApproval: false,
                  proformaApproval: false,
                  quotationApproval: false,
                  maintenanceApproval: false,
                };
              }

              this.UserPersonalDetail["employeeDepartment"] = [];

              if (
                this.UserPersonalDetail.designation == "surveyer" ||
                this.UserPersonalDetail.designation == "superviser"
              ) {
                let arrayNew23 = this.designationData.filter((x) => {
                  return x.designation == this.UserPersonalDetail.designation;
                });

                if (arrayNew23.length > 0) {
                  let arrapSplit = arrayNew23[0].departmentName.split(",");

                  this.showSegmentArray = this.tempShowSegmentArray.filter((y, index) => {
                    return arrapSplit.indexOf(y.departmentName) >= 0 ? true : false;
                  });
                }

                this.showSegmentArray.map((x, index) => {
                  let i = this.UserPersonalDetail.departmentId1.indexOf(x.departmentId);

                  i >= 0
                    ? (this.UserPersonalDetail.employeeDepartment[index] = true)
                    : (this.UserPersonalDetail.employeeDepartment[index] = false);
                });
              } else {
                this.showSegmentArray.map((x, index) => {
                  let i = this.UserPersonalDetail.departmentId1.indexOf(x.departmentId);

                  i >= 0
                    ? (this.UserPersonalDetail.employeeDepartment[index] = true)
                    : (this.UserPersonalDetail.employeeDepartment[index] = false);
                });
              }
              this.newArray("1");
            } else if (
              data.userDataDetails.length > 0 &&
              data.userDataDetails[0]["type"] == 2
            ) {
              this.UserPersonalDetail.type = "2";

              this.clientModal.clientId = data.userDataDetails[0].clientId;
              this.clientModal.clientUserName = data.userDataDetails[0].username;
              this.clientModal.clientPass = data.userDataDetails[0].employeeCode;
              this.clientModal.userId = data.userDataDetails[0].userId;
            } else {
              this.UserPersonalDetail.employeeCode = data.EmployeeCode;
            }

            this.isLoading = false;

            this.JqueryFun();
          }
        })
        .catch((error) => { });
    },

    SelectMultiBranch(items, lastSelectItem) {
      // alert("helwo")
      console.log("Priyanshu Singh=>", items[0]);
      // this.items.push(items);
      this.items = items;
      this.UserPersonalDetail.multibranch = items;
      // console.log('item=>',this.items);
    },
    SelectMultiPaymentTab(PaymentTabitems, lastSelectItem) {
   
      this.PaymentTabitems = PaymentTabitems;
      this.UserPersonalDetail.multiPaymentTab = PaymentTabitems;
    },
    handleRightsDataChanged(rightsData) {
      this.UserPersonalDetail.ape_shipment_type = rightsData.ape_shipment_type;
      this.UserPersonalDetail.ape_moduel_type = rightsData.ape_moduel_type;
      this.UserPersonalDetail.ape_job_type = rightsData.ape_job_type;
    },
  },
};
</script>
<style s>
.md-direction-bottom-right {
  width: 20% !important;
}

.mrgtop-2per {
  margin-top: 1%;
}

.mrgtop-5px {
  margin-top: 0px;
}

.center {
  text-align: center;
}

.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}

.userPermission {
  color: #0e0052;
}

.md-dialog-container.HereDialogPass.md-theme-default .md-dialog {
  width: 30%;
  height: 43%;
  border-radius: 10px;
}

.modalClose {
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 4px;
  line-height: 32px;
  margin-top: -21px;
  background-color: cyan;
}
</style>



// WEBPACK FOOTER //
// addUser.vue?3580b3cd